module.exports = __webpack_public_path__ + "img/image31.706ff3a6.png";